import React from 'react'
import { Checkbox } from 'antd'
import { BasicCheckboxContainer, StyledCheckboxContainer } from './styles'

export const BasicCheckboxGroup = ({ children, onChange }) => {
  return (
    <BasicCheckboxContainer>
      {children}
    </BasicCheckboxContainer>
  )
}

export const StyledCheckboxGroup = ({ options = [], value = [], onChange }) => {
  const handleChange = (optionValue, isChecked) => {
    const newValue = isChecked
      ? [...value, optionValue]
      : value.filter((v) => v !== optionValue)
    onChange?.(newValue)
  }

  return (
    <StyledCheckboxContainer>
      {options.map((option) => (
        <div key={option.value} className="checkbox-wrapper">
          <Checkbox
            checked={value.includes(option.value)}
            onChange={(e) => handleChange(option.value, e.target.checked)}
          >
            {option.label}
          </Checkbox>
        </div>
      ))}
    </StyledCheckboxContainer>
  )
}

const CheckboxGroup = {
  Basic: BasicCheckboxGroup,
  Styled: StyledCheckboxGroup
}

export default CheckboxGroup
